import { useTranslation } from "react-i18next";

export const OrderTipEmployeeName = ({ employeeName }: { employeeName: string }) => {
	const { t } = useTranslation();

	return (
		<h1 className="order-tips-header">
			{t("modules.e_order.field.tip_for.title")} <span className="text-primary">{employeeName}</span>
		</h1>
	);
};
